/**
 * Project status normalization — the backend historically stored a mix of
 * PT-BR canonical labels and legacy English labels (e.g. 'Completed',
 * 'In Progress', 'On Hold'). All UI badges should render the canonical
 * PT-BR label so users don't see inconsistent statuses across screens.
 */

const CANONICAL_ALIASES = {
  // Não Iniciado
  'Não Iniciado': 'Não Iniciado',
  'Not Started': 'Não Iniciado',
  'not_started': 'Não Iniciado',
  // Em Andamento
  'Em Andamento': 'Em Andamento',
  'In Progress': 'Em Andamento',
  'in_progress': 'Em Andamento',
  'Iniciado': 'Em Andamento',
  'Em andamento': 'Em Andamento',
  // Em Espera
  'Em Espera': 'Em Espera',
  'On Hold': 'Em Espera',
  'On Hold - Agency': 'Em Espera',
  'Paused': 'Em Espera',
  'Aguardando': 'Em Espera',
  // Concluído
  'Concluído': 'Concluído',
  'Completed': 'Concluído',
  'completed': 'Concluído',
  'Finalizado': 'Concluído',
  // Cancelado
  'Cancelado': 'Cancelado',
  'Cancelled': 'Cancelado',
  'cancelled': 'Cancelado',
};

const CANONICAL_COLORS = {
  'Não Iniciado': 'bg-gray-200 text-gray-700',
  'Em Andamento': 'bg-blue-100 text-blue-700',
  'Em Espera': 'bg-yellow-100 text-yellow-700',
  'Concluído': 'bg-green-100 text-green-700',
  'Cancelado': 'bg-red-100 text-red-700',
};

/** Return the canonical PT-BR label for a stored project status. */
export function normalizeProjectStatus(raw) {
  if (!raw) return 'Não Iniciado';
  return CANONICAL_ALIASES[raw] || raw;
}

/** Return Tailwind classes for the canonical status (accepts any alias). */
export function getProjectStatusColor(raw) {
  const canonical = normalizeProjectStatus(raw);
  return CANONICAL_COLORS[canonical] || 'bg-gray-200 text-gray-700';
}
